// extracted by mini-css-extract-plugin
export default {"page":"request_page__1JGi2"};